module.exports = __webpack_public_path__ + "static/media/my-image.42063337.jpg";